<template>
  <v-app id="app">
    <v-app-bar
      app
      color="primary"
      dark
      id="bar"
      height="80px;"
    >
    <!--<div :style="'height:100%;width:30px;' + 'background-color:' + $config.COL_HOME_ACCENT"></div>-->
    <a href="http://www.lhmp.org/">
    <img src="/mp1.png" height="75px;" />
    </a>
      <!--<v-toolbar-title class="text-h4 text-uppercase pl-5">{{$config.TITLE}}</v-toolbar-title>-->
    </v-app-bar>
    <v-main style="height:100%; background: url('/distinguished-site-1.jpg')  no-repeat center center fixed; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;" >
      <v-container fluid style="background-color: transparent">
        <router-view/>
      </v-container>
    </v-main>
    <v-footer app>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
    }
  },
  beforeCreate () {
    document.title = this.$config.APP_TITLE
  },
  watch: {
  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
